import * as React from 'react';
// mui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
// redux
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { updateProject } from '../../store/slices/projectsSlice';
// axios
import api from '../../axios';
// types
import Project from '../../interfaces/Project.interface';

interface RenameProjectDialogProps {
  onClose: () => void;
  focusedProject: Project | null;
}

export default function RenameProjectDialog(props: RenameProjectDialogProps) {
  // props
  const onCloseCallback = props.onClose;
  const focusedProject = props.focusedProject;

  // hooks
  const dispatch = useDispatch<AppDispatch>();

  // state
  const [ showRenameProjectDialog, setShowRenameProjectDialog ] = React.useState<boolean>(true);
  const [ renameProjectName, setRenameProjectName ] = React.useState<string>(focusedProject?.name || '');
  const [ renameLoading, setRenameLoading ] = React.useState<boolean>(false);

  const handleRenameProject = () => {
    setRenameLoading(true);

    if (focusedProject !== null) {
      api.put(`/projects/update/${focusedProject.id}`, {
        name: renameProjectName
      })
        .then((res) => {
          console.log(res);
          const updatedProject: Project = res.data;
          dispatch(updateProject(updatedProject));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setRenameLoading(false);
          setShowRenameProjectDialog(false);
          setRenameProjectName('');
        });
    }
  }

  return (
    <Dialog
      open={showRenameProjectDialog}
      onClose={() => { setShowRenameProjectDialog(false); onCloseCallback(); }}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
          },
        },
      }}
    >
      <DialogTitle>
        Rename Project
      </DialogTitle>
      <DialogContent>
        <TextField
          sx={{ minWidth: 300 }}
          label="Project Name"
          value={renameProjectName}
          onChange={(e) => { setRenameProjectName(e.target.value); }}
          autoFocus
          required
          id="name"
          variant="standard"
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={() => { setShowRenameProjectDialog(false); onCloseCallback(); }}>Cancel</Button>
        <Button
          variant='contained'
          type='submit'
          loading={renameLoading}
          disabled={renameProjectName.length < 1}
          onClick={() => { handleRenameProject(); onCloseCallback(); }}
        >Rename</Button>
      </DialogActions>
    </Dialog>
  )
}